import PropTypes from "prop-types";

export default {
  /**
   ** Indica si el componente está dentro de un formulario
   **/
  isInsideForm: PropTypes.bool,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Etiqueta opcional para el campo
   */
  label: PropTypes.string,
  /**
   * Valor actual del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Función que se ejecuta al cambiar el valor del campo
   */
  onChange: PropTypes.func,
  /**
   * Id del input del componente
   */
  id: PropTypes.string,
  /**
   * Name del input del componente
   */
  name: PropTypes.string,
  /**
   * Valores a excluir en el selector
   */
  excluded: PropTypes.array,
  /**
   * Indica si se selecciona por defecto el primer valor si solamente hay uno
   */
  setFirstIfOnlyOneValue: PropTypes.bool,
  /**
   * Número máximo de elementos
   */
  limit: PropTypes.number,
  /**
   * Variables de la query a sobreescribir
   */
  variables: PropTypes.object,
  /**
   * Indica si se aplican los estilos para placeholders multilínea en dispositivos móviles
   */
  marginDense: PropTypes.bool,
};
